const LOG_REGEX = /\bnabjslog\b/;
export function log( ...args: unknown[] ): void {
	if (
		LOG_REGEX.test( window.location.search ) ||
		LOG_REGEX.test( document.cookie )
	) {
		// eslint-disable-next-line no-console
		console.log( '[NAB]', ...args );
	}
}

export function logIf( condition: boolean, ...args: unknown[] ): void {
	if ( ! condition ) {
		return;
	}
	log( ...args );
}
